import * as Cesium from "cesium";
import {reservoirPosition} from "@/common/js/position";

/**
 *  实体广告牌
 */
export default class DragEntity{
    constructor(val){
        this.viewer = val.viewer
    }

    /**
     * 广告牌
     * @param value
     * @returns {Entity}
     */
    addRiverEntity(value){
        let pinBuilder = new Cesium.PinBuilder();
        let poin = this.viewer.entities.add({
            name: value.name,
            position: Cesium.Cartesian3.fromDegrees(value.location[0],value.location[1],value.location[2]),
            monitoItems:{
                data:value
            },
            label: {
                // show: false,
                text: value.name,
                font: "10px Helvetica",
                fillColor: Cesium.Color.ORANGE,
                outlineColor: Cesium.Color.BLACK,
                outlineWidth: 2,
                style: Cesium.LabelStyle.FILL_AND_OUTLINE,
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM, // 垂直方向以底部来计算标签的位置
                pixelOffset: new Cesium.Cartesian2(0, -20), // 偏移量
                disableDepthTestDistance:Number.POSITIVE_INFINITY,
            },
        });

        return poin
    }



    /**
     * 广告牌
     * @param value
     * @returns {Entity}
     */
    addMonitoring(value){
        let pinBuilder = new Cesium.PinBuilder();
        let poin = this.viewer.entities.add({
            // id:value.id,
            name: value.name,
            position: Cesium.Cartesian3.fromDegrees(value.location[0],value.location[1],value.location[2]),
            billboard: {
                image: pinBuilder.fromMakiIconId  (value.type,Cesium.Color.ROYALBLUE, 40),
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                disableDepthTestDistance:Number.POSITIVE_INFINITY,
                scaleByDistance: new Cesium.NearFarScalar(2000, 1, 8000, 0),
            },
            label: {
                // show: false,
                scaleByDistance: new Cesium.NearFarScalar(2000, 1, 8000, 0),
                text: value.name,
                disableDepthTestDistance:Number.POSITIVE_INFINITY,
                font: "20px Helvetica",
                fillColor: Cesium.Color.WHITE,
                outlineColor: Cesium.Color.BLACK,
                outlineWidth: 2,
                style: Cesium.LabelStyle.FILL_AND_OUTLINE,
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM, // 垂直方向以底部来计算标签的位置
                pixelOffset: new Cesium.Cartesian2(0, -40), // 偏移量
            },
            monitoItems:{
                data:value
            },
        });

        return poin
    }
    addPointEntity(value){
        let poin=this.viewer.entities.add({
            // fromDegrees（经度，纬度，高度，椭球，结果）从以度为单位的经度和纬度值返回Cartesian3位置
            position: Cesium.Cartesian3.fromDegrees(value.location[0],value.location[1],value.location[2]| 200),
            point: {
                // 点的大小（像素）
                pixelSize: 10,
                // 点位颜色，fromCssColorString 可以直接使用CSS颜色
                color: Cesium.Color.fromCssColorString(value.color),
                // 边框颜色
                outlineColor: Cesium.Color.fromCssColorString('#fff'),
                // 边框宽度(像素)
                outlineWidth: 2,
                // 显示在距相机的距离处的属性，多少区间内是可以显示的
                // distanceDisplayCondition: new Cesium.DistanceDisplayCondition(0, 1500),
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                disableDepthTestDistance: Number.POSITIVE_INFINITY,
                scaleByDistance: new Cesium.NearFarScalar(0, 1, 500000, 0.3),
                // 是否显示
                show: true
            },
            label: {
                text: value.name,
                font: '10pt bold Source Han Sans CN', // 字体样式
                // fillColor: Cesium.Color.fromCssColorString(r),
                style: Cesium.LabelStyle.FILL, // label样式
                outlineColor: Cesium.Color.BLACK,   // 外边线颜色
                outlineWidth: 4,
                showBackground: true,   // 是否显示背景
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM, // 垂直方向以底部来计算标签的位置
                pixelOffset: new Cesium.Cartesian2(0, -20), // 偏移量
                disableDepthTestDistance: Number.POSITIVE_INFINITY,
                scaleByDistance: new Cesium.NearFarScalar(0, 1, 500000, 0.3),
            },
            monitoItems: {
                data: value
            },
        });
        return poin
    }
    addReservoir(value){
        let poin = this.viewer.entities.add({
            // id:value.id,
            name: value.name,
            position: Cesium.Cartesian3.fromDegrees(value.location[0],value.location[1],value.location[2]),
            point: {
                pixelSize: 14,
                color: Cesium.Color.fromCssColorString(value.color || '#00BFFF'),
                outlineColor: Cesium.Color.WHITE,
                outlineWidth: 2,
                disableDepthTestDistance: Number.POSITIVE_INFINITY,
                scaleByDistance: new Cesium.NearFarScalar(0, 1, 800000, 0.5),
            },
            billboard: {
                image: require("@/assets/中型水库.png"),
                width: 40,
                height: 40,
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                disableDepthTestDistance:Number.POSITIVE_INFINITY,
                scaleByDistance: new Cesium.NearFarScalar(0, 1, 800000, 0.5),
            },
            label: {
                // show: false,
                text: value.name,
                font: '10pt bold Source Han Sans CN', // 字体样式
                fillColor: Cesium.Color.fromCssColorString(value.color || '#00BFFF'),
                style: Cesium.LabelStyle.FILL, // label样式
                outlineColor: Cesium.Color.BLACK,   // 外边线颜色
                outlineWidth: 4,
                showBackground: true,   // 是否显示背景
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM, // 垂直方向以底部来计算标签的位置
                pixelOffset: new Cesium.Cartesian2(0, -45), // 偏移量
                disableDepthTestDistance:Number.POSITIVE_INFINITY,
                scaleByDistance: new Cesium.NearFarScalar(0, 1, 800000, 0.5),
            },
            monitoItems:{
                data:value
            },
        });

        return poin
    }

    addEntity(value){
        let pinBuilder = new Cesium.PinBuilder();
        let poin = this.viewer.entities.add({
            name: value.name,
            position: Cesium.Cartesian3.fromDegrees(value.location[0],value.location[1],value.location[2]),
            billboard: {
                image: pinBuilder.fromMakiIconId  (value.type, Cesium.Color.fromCssColorString(value.color), 20),
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                disableDepthTestDistance:Number.POSITIVE_INFINITY,
            },
            monitoItems:{
                data:value
            },
            label: {
                // show: false,
                text: value.name,
                font: '10pt bold Source Han Sans CN', // 字体样式
                fillColor: Cesium.Color.fromCssColorString(value.color),
                style: Cesium.LabelStyle.FILL, // label样式
                outlineColor: Cesium.Color.BLACK,   // 外边线颜色
                outlineWidth: 4,
                showBackground: true,   // 是否显示背景
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM, // 垂直方向以底部来计算标签的位置
                pixelOffset: new Cesium.Cartesian2(0, -20), // 偏移量
                disableDepthTestDistance:Number.POSITIVE_INFINITY,
            },
        });

        return poin
    }

    addTextEntity(value){
        let poin = this.viewer.entities.add({
            name: value.name,
            position: Cesium.Cartesian3.fromDegrees(value.location[0],value.location[1]),
            monitoItems:{
                data:value
            },
            label: {
                text: value.name,
                font: "12px Helvetica",
                fillColor: Cesium.Color.fromCssColorString(value.color),
                outlineColor: Cesium.Color.BLACK,
                outlineWidth: 2,
                style: Cesium.LabelStyle.FILL_AND_OUTLINE,
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM, // 垂直方向以底部来计算标签的位置
                disableDepthTestDistance:Number.POSITIVE_INFINITY,
            },
        });

        return poin
    }

    addScaleEntity(value){
        let pinBuilder = new Cesium.PinBuilder();
        let poin = this.viewer.entities.add({
            // id:value.id,
            name: value.name,
            position: Cesium.Cartesian3.fromDegrees(value.location[0],value.location[1],value.location[2]),
            billboard: {
                image: pinBuilder.fromMakiIconId  (value.type,Cesium.Color.fromCssColorString(value.color), 20),
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                disableDepthTestDistance:Number.POSITIVE_INFINITY,
                scaleByDistance: new Cesium.NearFarScalar(100000, 1, 200000, 0),
            },
            label: {
                // show: false,
                scaleByDistance: new Cesium.NearFarScalar(100000, 1, 200000, 0),
                text: value.name,
                disableDepthTestDistance:Number.POSITIVE_INFINITY,
                font: "14px Helvetica",
                fillColor: Cesium.Color.WHITE,
                outlineColor: Cesium.Color.BLACK,
                outlineWidth: 2,
                style: Cesium.LabelStyle.FILL_AND_OUTLINE,
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM, // 垂直方向以底部来计算标签的位置
                pixelOffset: new Cesium.Cartesian2(0, -20), // 偏移量
            },
            monitoItems:{
                data:value
            },
        });

        return poin
    }

}
